module.exports = __webpack_public_path__ + "img/wisdomCampus-1.0462cb34.gif";